import 'l10nModule';
import MetadataDrivenUIService from './MetadataDrivenUIService';
import MetadataDrivenComponent from './components/MetadataDriven';
import DynamicAttr from './directives/DynamicAttr';

export default angular.module('edge.platform.metadataDrivenUI', ['edge.platform.l10n'])
    .component('gwMetadataDriven', MetadataDrivenComponent)
    .directive('gwDynamicAttr', DynamicAttr)
    .factory('MetadataDrivenUIService', MetadataDrivenUIService);
